import React from "react";

export default function History_Robots() {
  return (
    <div>
      <h1>History_Robots</h1>
      <p>This is the History_Robots component.</p>
    </div>
  );
}
